import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import MyInput from "../../../../Reusable/MyInput";
import { useNavigate } from "react-router-dom";
import GRNCreatePageForm from "./GRNCreatePageForm";
import { GRNTypeSelect } from "./GRNTypeSelect";
import { UserContext } from "../../../../Context/UserContext";
import { BaseURL } from "../../../../Reusable/BaseURL";
import Button from "../../../../Reusable/Button";
import { GRNPOSelect } from "./GRNPOSelect";
import { GRNGPSelect } from "./GRNGPSelect";
import { GRNPaymentTypeSelect } from "./GRNPaymentTypeSelect";
import MyTextarea from "../../../../Reusable/MyTextarea";
import { confirmAlert } from "react-confirm-alert";
import { CustomConfirmDialog } from "../../../../Reusable/CustomConfirmDialog";

export default function GRNCreate() {
  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
  } = useContext(UserContext);

  const [division, setDivision] = useState("");
  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  // const [severity, setSeverity] = useState("Normal");
  const [itemSeverity, setItemSeverity] = useState("Normal");

  const [qty, setQty] = useState("");
  const [ewayBillNo, setEwayBillNo] = useState("");
  const [ewayBillDate, setEwayBillDate] = useState("");
  const [receiveAmt, setReceiveAmt] = useState("");
  const [grnType, setGrnType] = useState("");
  const [grnPO, setGrnPO] = useState("");
  const [grnGP, setGrnGP] = useState("");
  const [paymentType, setPaymentType] = useState("CASH");
  const [date, setDate] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [remark, setRemark] = useState("");
  const [grnPartyId, setGrnPartyId] = useState("");
  const [partyDetail, setPartyDetail] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");

  const navigate = useNavigate();

  // TODAY CURRENT DATE DEFAULT SET
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setDate(formattedDate);
    // setCacheFun();
  }, []);

  useEffect(() => {
    setCacheFun();
  }, [date]);

  useEffect(() => {
    // getAllIndentCreated();
    // getUnsavedItemList();
  }, []);

  // OnBlur DATE
  async function postCacheItemDate() {
    const selectedData = { date: date };
    const response = await fetch(`${BaseURL}/purchase/indent/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // OnBlur REMARK
  async function postCacheItemRemark() {
    const selectedData = { remarks: remark };
    const response = await fetch(`${BaseURL}/purchase/indent/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
    // console.log("remarks", data);
    // console.log("remarks", selectedData);
  }

  async function getUnsavedItemList() {
    setSpinner(true);
    const res = await fetch(`${BaseURL}/purchase/grn/getcache`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // const cacheItems = createRes.data.items || [];

          const cacheItems =
            createRes.data !== null ? createRes.data.items : [];

          // const reverseCacheItems = cacheItems.reverse();
          // setUnsavedIndentItem(createRes.data.items || []);
          setUnsavedIndentItem(cacheItems);

          // const mygetdivision = createRes.data?.items[0];
          // const cacheDivision = mygetdivision.division;
          // setMyCacheDivision(cacheDivision || "");

          // const mygetdivision =
          //   createRes.data !== null ? createRes.data?.items[0] : {};
          // const cacheDivision = mygetdivision?.division || "";
          // setMyCacheDivision(cacheDivision || "");

          const myCacheDiv = createRes?.data?.division;
          const myCacheDate = createRes?.data?.date;
          const myCacheRemark = createRes?.data?.remarks;
          setMyCacheDivision(myCacheDiv || "");
          setDate(myCacheDate || "");
          setRemark(myCacheRemark || "");


          setEwayBillDate(createRes?.date?.ewaybill_date)
          setEwayBillNo(createRes?.date?.ewaybill_no)

          setSpinner(false);
        } else {
          setSpinner(false);
        }
      });
    // setSpinner(false)
  }
  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  // ADD INDENT ITEM
  async function addIndentItem(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("item_id", item.value || "");
    // formData.append("brand_id", brand.value || "");
    // formData.append("unit_id", unit.value || "");
    // formData.append("qty", qty || "");

    if (division !== "") {
      setItemSubmitDisable(true);
      const formData = {
        severity: itemSeverity.value || "",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty,
      };

      const res = await fetch(`${BaseURL}/purchase/indent/setcacheitems`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            setAddMoreToggle(false);
            getUnsavedItemList();
            setItem("");
            setBrand("");
            setUnit("");
            setQty("");
            toast.success("Added on lists");
            setItemSubmitDisable(false);
          }
          if (createRes.status === false) {
            setItemSubmitDisable(false);
          }
          if (createRes?.error?.message.item_id) {
            toast.error(createRes.error.message.item_id);
          } else if (createRes?.error?.message.brand_id) {
            toast.error(createRes.error.message.brand_id);
          } else if (createRes?.error?.message.unit) {
            toast.error(createRes.error.message.unit);
          } else if (createRes?.error?.message.qty) {
            toast.error(createRes.error.message.qty);
          } else if (createRes?.error?.message.severity) {
            toast.error(createRes.error.message.severity);
          }
        });
    } else {
      toast.error("First Select Division.!");
      setItemSubmitDisable(false);
    }
  }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
 
  // DIALOG BOX MODAL: SUBMIT
  const showDialog = (e) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomConfirmDialog
            title="Check"
            message="Kindly confirm the GST No. is....in the Client Invoice."
            onConfirm={() => {
              // const changeConfirm = async () => {
  
              // };
              // changeConfirm();
              createDivision(e);
              onClose();
            }}
            onCancel={onClose}
          />
        );
      },
    });
  };
  async function createDivision(e) {
    e.preventDefault();
    if (unsavedIndentItem.length <= 0) {
      toast.error("Add items before submit.");
      return;
    }
    setSubmitDisable(true);

    const updatedGrnData = unsavedIndentItem.map((elem, index) => ({
      id: elem.id,
      grn_qty: elem.grn_qty,
      grn_unit_rate: elem.grn_unit_rate,
      grn_amount: elem.grn_amount,
    }));

    // return console.log("updated grn", updatedGrnData)

    const formData = {
      type: grnType.label || "",
      // payment_type: paymentType.label || "",
      party_id: grnPO?.party_id
        ? grnPO.party_id
        : grnGP?.party_id
        ? grnGP.party_id
        : "" || "",
      division: null,
      date: date || "",
      invoice_no: invoiceNo || "",
      invoice_date: invoiceDate || "",
      vehicle_no: vehicleNo || "",
      remarks: remark || "",
      items: updatedGrnData,
      ewaybill_no: ewayBillNo || "",
      ewaybill_date: ewayBillDate || "",
    };

    const res = await fetch(`${BaseURL}/purchase/grn/creategrn`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          getUnsavedItemList();
          toast.success("Success");
          navigate("/purchase/pending-grn-view");
          setDivision("");
          setItem("");
          setBrand("");
          setUnit("");
          setQty("");

          setDate("");
          // setSeverity("");
          setRemark("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.type) {
          toast.error(createRes.error.message.type);
        } else if (createRes?.error?.message.party_id) {
          toast.error(createRes.error.message.party_id);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    // without endpoint hit===========
    setEditDisable(true);
    setChangingSelect(true);
    setAddMoreToggle(true);
    setSubmitAction("update");

    setDivision(editData.division || "");
    setItem(editData.item_name || "");
    setItemSeverity(editData.severity || "");
    setBrand(editData.brand || "");
    setUnit(editData.unit || "");
    setQty(editData.qty || "");
    setEditDisable(false);

    // with api hit ============
    // setEditDisable(true);
    // fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
    //   method: "GET",
    //   headers: {
    //     Accept: "application/json",
    //     Authorization: `Bearer ${loginData.token}`,
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((selectedRecord) => {
    //     if (selectedRecord.status) {
    //       setChangingSelect(true);
    //       setAddMoreToggle(true);
    //       setSubmitAction("update");

    //       setDivision(selectedRecord.data.division || "");
    //       setItem(selectedRecord.data.item_name || "");
    //       setItemSeverity(selectedRecord.data.severity || "");
    //       setBrand(selectedRecord.data.brand || "");
    //       setUnit(selectedRecord.data.unit || "");
    //       setQty(selectedRecord.data.qty || "");
    //       setEditDisable(false);
    //     }
    //     if (selectedRecord.status === false) {
    //       setEditDisable(false);
    //     }
    //   });
    // setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateIndentItem(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    if (division !== "") {
      const formData = {
        severity: itemSeverity.value || "",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || "",
      };
      const updRes = await fetch(
        `${BaseURL}/purchase/indent/updatecacheitem/${id}`,
        {
          method: "PATCH",
          body: JSON.stringify(formData),
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({name: divisionName}),
        }
      )
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            getUnsavedItemList();
            setGetId(0);
            setItem("");
            setBrand("");
            setUnit("");
            setQty("");

            setSubmitAction("submit");
            setAddMoreToggle(false);
            toast.success("Updated");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.item_id) {
            toast.error(upd.error.message.item_id);
          } else if (upd?.error?.message.brand_id) {
            toast.error(upd.error.message.brand_id);
          } else if (upd?.error?.message.unit) {
            toast.error(upd.error.message.unit);
          } else if (upd?.error?.message.qty) {
            toast.error(upd.error.message.qty);
          } else if (upd?.error?.message) {
            toast.error(upd.error.message);
          }
        });
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);
    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  function cancelPopup() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
    setSubmitAction("submit");
  }

  function popupCreateIndentOnClickOut() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");
    setSubmitAction("submit");
    // setDivision("");
  }

  // SET-CACHE FUN
  async function setCacheFun() {
    const selectedData = {
      // "type": gatePassType.label || "",
      //   "subtype": gatePassInType.label || "",
      // "party_id": choosePO.party_id || "",
      date: date || "",
      invoice_no: invoiceNo || "",
      invoice_date: invoiceDate || "",
      vehicle_no: vehicleNo || "",
      remarks: remark || "",
      ewaybill_no: ewayBillNo || "",
      ewaybill_date: ewayBillDate || "",
    };
    // return console.log("cache data", selectedData)
    const response = await fetch(`${BaseURL}/purchase/grn/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    // const data = await response.json();
  }

  // GRN: TYPE SET CACHE
  async function setCacheTypeFun(type) {
    const selectedData = { type: type.label };
    // return console.log("typpe", selectedData)
    const response = await fetch(`${BaseURL}/purchase/grn/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // Party Id SET CACHE fun
  async function setCachePartyIdFun(pId) {
    const selectedData = { party_id: pId?.party_id };
    const response = await fetch(`${BaseURL}/purchase/grn/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // Payment Type: SET CACHE function
  async function setCachePaymentFun(type) {
    const selectedData = { payment_type: type.label };
    const response = await fetch(`${BaseURL}/purchase/grn/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // GET PARTY DETAIL FUNC
  const getPartyDetailFun = async (partyId) => {
    const res = await fetch(`${BaseURL}/parties/${partyId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await res.json();
    if (data.status) {
      setPartyDetail(data.data.name);
    } else {
      toast.error("Party Detail not found!");
    }
  };

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            GRN Create
          </div>
          <div className="mb-2">
            <div className="grid grid-cols-1">
              {/* LEFT PART  */}
              <div className="px-2 w-full">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4 md:gap-x-3">
                    <div className="mb-2 w-full">
                      <label>
                        GRN Type{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <GRNTypeSelect
                        selectedOption={grnType}
                        setSelectedOption={setGrnType}
                        setPartyDetail={setPartyDetail}
                        setCacheTypeFun={setCacheTypeFun}
                        setGrnGP={setGrnGP}
                        setGrnPO={setGrnPO}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                      />
                    </div>
                    {grnType?.label === "PO" && (
                      <div className="mb-2 w-full">
                        <label>
                          Choose PO{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GRNPOSelect
                          selectedOption={grnPO}
                          setSelectedOption={setGrnPO}
                          setChangingSelect={setChangingSelect}
                          changingSelect={changingSelect}
                          getUnsavedItemList={getUnsavedItemList}
                          getPartyDetailFun={getPartyDetailFun}
                          setCachePartyIdFun={setCachePartyIdFun}
                        />
                      </div>
                    )}
                    {grnType?.label === "GATE-PASS" && (
                      <div className="mb-2 w-full">
                        <label>
                          Choose GP{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GRNGPSelect
                          selectedOption={grnGP}
                          setSelectedOption={setGrnGP}
                          setChangingSelect={setChangingSelect}
                          changingSelect={changingSelect}
                          getUnsavedItemList={getUnsavedItemList}
                          getPartyDetailFun={getPartyDetailFun}
                          setCachePartyIdFun={setCachePartyIdFun}
                        />
                      </div>
                    )}
                    {grnType?.label && (
                      <MyInput
                        label="Party"
                        type="text"
                        value={
                          grnGP?.party_id
                            ? partyDetail
                            : grnPO?.party_id
                            ? partyDetail
                            : ""
                        }
                        // onChange={(e) => setParty(e.target.value)}
                        className="w-full"
                        // mendatory="*"
                        readOnly
                      />
                    )}

                    <MyInput
                      label="Vehicle No."
                      type="text"
                      value={vehicleNo}
                      onChange={(e) => setVehicleNo(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      onBlur={() => setCacheFun()}
                    />
                    <MyTextarea
                      label="Invoice/Challan Detail"
                      type="text"
                      className="w-full"
                      value={invoiceNo}
                      onChange={(e) => setInvoiceNo(e.target.value)}
                      onBlur={() => setCacheFun()}
                    />
                    {/* <div className="flex"> */}
                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Invoice Date{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <input
                        onBlur={() => setCacheFun()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={invoiceDate}
                        onChange={(e) => setInvoiceDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>
                    {/* <div className="mb-2 w-full">
                        <label className="mr-2 block mb-[4px]">
                          Date <span className="text-red-500 font-bold">*</span>
                        </label>
                        <input
                          onBlur={() => setCacheFun()}
                          className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                            darkTheme
                              ? "bg-gray-700 border-gray-500"
                              : "bg-white border-gray-500"
                          }`}
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                          type="date"
                          name="date"
                        />
                      </div> */}
                    {/* </div> */}

                    {/* <div className="mb-2 w-full">
                      <label>
                        Payment Type{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <GRNPaymentTypeSelect
                        selectedOption={paymentType}
                        setSelectedOption={setPaymentType}
                        setCachePaymentFun={setCachePaymentFun}
                      />
                    </div> */}

                    <MyInput
                      label="Eway Bill No."
                      type="text"
                      value={ewayBillNo}
                      onChange={(e) => setEwayBillNo(e.target.value)}
                      className="w-full"
                      // mendatory="*"
                      onBlur={() => setCacheFun()}
                    />

                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Eway Bill Date{" "}
                        {/* <span className="text-red-500 font-bold">*</span> */}
                      </label>
                      <input
                        onBlur={() => setCacheFun()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={ewayBillDate}
                        onChange={(e) => setEwayBillDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>

                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onBlur={() => setCacheFun()}
                    />
                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Date <span className="text-red-500 font-bold">*</span>
                      </label>
                      <input
                        onBlur={() => setCacheFun()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}

              {/* RIGHT PART  */}
              {/* <div className="bg-[#8CDDCD] rounded-xl p-3">
                <div className="mb-2 grid grid-cols-2 md:grid-cols-4 gap-x-2">
                  <MyInput
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    label="Receive Qty"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                  <MyInput
                    value={receiveAmt}
                    onChange={(e) => setReceiveAmt(e.target.value)}
                    label="Receive Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                    readOnly
                  />
                </div>
                <div className="flex items-center justify-start gap-1">
                  {submitAction === "submit" && (
                    <Button
                      disabled={itemSubmitDisable}
                      type="submit"
                      onClick={(e) => addIndentItem(e)}
                      className="!bg-yellow-600"
                    >
                      {itemSubmitDisable ? "Wait.." : "Add Item"}
                    </Button>
                  )}
                  {submitAction !== "submit" && (
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateIndentItem(e, getId)}
                      className="!bg-yellow-600"
                    >
                      {updateDisable ? "Wait.." : "Update Item"}
                    </Button>
                  )}
                  <Button
                    onClick={() => cancelPopup()}
                    className="!bg-gray-200 !text-black"
                  >
                    Cancel
                  </Button>
                </div>
              </div> */}
              {/* END RIGHT PART  */}
            </div>
          </div>

          {/* ITEM LIST FORM  */}
          <div className="w-full px-2 mb-4">
            <GRNCreatePageForm
              editBtn={editBtn}
              firstPageList={getUnsavedItemList}
              links={links}
              firstPage={unsavedIndentItem}
              setFirstPage={setUnsavedIndentItem}
              setGetId={setGetId}
              spinner={spinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
              editDisable={editDisable}
            />
          </div>

          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                disabled={submitDisable}
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                onClick={(e) => showDialog(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
